import { Download } from '@mui/icons-material';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import theme from '../../../../../assets/theme/theme';
import { DisplayDateTime, GetFileSize } from '../../../../../utils/formats';

interface MUIDownloadFileProps {
	fileMetaData: any;
	onDownload: () => {};
	downloadedOn: string;
	readonly?: boolean;
	disabled?: boolean;
	multipleFiles?: boolean;
	showDownloadedOn?: boolean;
	showDownloadButton?: boolean;
}

const MUIDownloadFile: FC<MUIDownloadFileProps> = ({
	fileMetaData,
	onDownload,
	downloadedOn,
	disabled = false,
	readonly = false,
	multipleFiles = false,
	showDownloadedOn = true,
	showDownloadButton = true,
}) => {
	console.log('disabled', disabled, 'readOnly', readonly);

	return (
		<>
			<TableContainer
				sx={{
					mt: 2,
					borderRadius: 2,
					// boxShadow: 3,
					// border: '1px solid #e0e0e0',
					'&:hover': {
						boxShadow: 2,
					},
				}}
			>
				<Table>
					<TableHead sx={{ backgroundColor: theme.palette.background.paper }}>
						<TableRow>
							<TableCell>Dateiname</TableCell>
							<TableCell align='right'>Dateigröße</TableCell>
							{showDownloadedOn && <TableCell align='right'>Heruntergeladen am</TableCell>}
							<TableCell align='right'>Aktion</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{multipleFiles ?
							<>
								{(Array.isArray(fileMetaData) ? fileMetaData : []).map((eachFile, i) => (
									<TableRow
										key={i}
										sx={{
											'&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
											'&:hover': { backgroundColor: '#f0f8ff' },
										}}
									>
										<TableCell>{get(eachFile, 'attributes.name')}</TableCell>
										<TableCell align='right'>{GetFileSize(get(eachFile, 'attributes.size') / (get(eachFile, 'id') ? 1 : 1000))}</TableCell>
										{showDownloadedOn && <TableCell align='right'>{DisplayDateTime(downloadedOn)}</TableCell>}
										<TableCell align='right'>
											{showDownloadButton && get(eachFile, 'attributes.url', '') && (
												<Tooltip title='Herunterladen'>
													<IconButton
														aria-label='Herunterladen'
														color='primary'
														onClick={() => {
															onDownload();
														}}
													>
														<Download />
													</IconButton>
												</Tooltip>
											)}
										</TableCell>
									</TableRow>
								))}
							</>
						:	<TableRow
								sx={{
									'&:hover': { backgroundColor: '#f0f8ff' },
								}}
							>
								<TableCell>{get(fileMetaData, 'attributes.name')}</TableCell>
								<TableCell align='right'>{GetFileSize(get(fileMetaData, 'attributes.size') / (get(fileMetaData, 'id') ? 1 : 1000))}</TableCell>
								{showDownloadedOn && <TableCell align='right'>{DisplayDateTime(downloadedOn)}</TableCell>}
								<TableCell align='right'>
									{showDownloadButton && get(fileMetaData, 'attributes.url', '') && (
										<Tooltip title='Herunterladen'>
											<IconButton
												aria-label='Herunterladen'
												color='primary'
												onClick={() => {
													if (typeof onDownload === 'function') {
														onDownload();
													}
												}}
											>
												<Download />
											</IconButton>
										</Tooltip>
									)}
								</TableCell>
							</TableRow>
						}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};

export default MUIDownloadFile;
